import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


const MenuTooltip = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <a className="table-icon" href="#">{children}</a>
    </OverlayTrigger>
  ); 
    

export default MenuTooltip;